import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidatorFn} from '@angular/forms';
import {FileInput, FileValidator} from 'ngx-material-file-input';
import {Observable, of, ReplaySubject, zip} from 'rxjs';
import {debounceTime, delay, distinctUntilChanged, filter, first, takeUntil, tap} from 'rxjs/operators';
import {
  DictService,
  FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
  FILE_TYPE_ALLIANZ_CERT,
  FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
  FILE_TYPE_ALLIANZ_CERT_FRAUDS,
  FILE_TYPE_ALLIANZ_CERT_MY_CAR,
  FILE_TYPE_ANNEX,
  FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
  FILE_TYPE_ANNEX_OFWCA_APPLICATION,
  FILE_TYPE_ANOTHER_MULTI,
  FILE_TYPE_AUTHORIZATION,
  FILE_TYPE_CERT_100P,
  FILE_TYPE_CERT_40P,
  FILE_TYPE_CONFIDENTIALITY_AGREEMENT,
  FILE_TYPE_CONTRACT,
  FILE_TYPE_CONTRACT_TERMINATION,
  FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
  FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS,
  FILE_TYPE_DIPLOMA,
  FILE_TYPE_IDD_TRAINING_STATEMENT,
  FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
  FILE_TYPE_INITIAL_TRAINING,
  FILE_TYPE_KRK,
  FILE_TYPE_KRS_CEIDG,
  FILE_TYPE_OVERCOMMISSION_AGREEMENT,
  FILE_TYPE_OFWCA_APPLICATION,
  FILE_TYPE_PARTNER_DATA,
  FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU,
  FILE_TYPE_RECEIPT_PROTOCOL,
  FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE,
  FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM,
  FILE_TYPE_ANNEX_LEAD,
  FILE_TYPE_PERSONAL_DATA_CHANGE,
  FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE,
  FILE_TYPE_HANDOVER_PROTOCOL,
  FILE_TYPE_RETURN_PROTOCOL,
  FILE_TYPE_ANNEX_AUTOMATIC_BILLING,
  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING,
  FILE_TYPE_MANDATE_QUESTIONNAIRE,
  FILE_TYPE_AWARD_RECEPTION_PROTOCOL,
  FILE_TYPE_AML_CERTIFICATE,
  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING
} from '../../../shared/services/dict.service';
import {DocumentService} from '../../../shared/services/document.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Contract} from '../../../shared/interface/contract';
import {MatDialogRef} from '@angular/material/dialog';
import {DocumentAddDialogComponent} from '../document-add-dialog/document-add-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Document} from '../../../shared/interface/document';
import {ContractSelectCardComponent} from '../../forms/contract-select-card/contract-select-card.component';
import {Ofwca} from '../../../shared/interface/ofwca';
import {Partner} from '../../../shared/interface/partner';
import {Krk} from '../../../shared/interface/krk';
import {Registration} from '../../../shared/interface/registration';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {
  IC_ERGO_HESTIA, IC_GENERALI, IC_INTER_POLSKA,
  IC_INTER_POLSKA_LIFE, IC_METLIFE, IC_PRU,
  IC_PZU, IC_PZU_LIFE, IC_TRASTI, IC_WARTA
} from '../../../shared/services/insurance-company.service';
import {migrateFileContent} from "@angular/material/schematics/ng-update/migrations/theming-api-v12/migration";
import {THREE} from "@angular/cdk/keycodes";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {DictRegistrationsComponent} from "../../../shared/components/dict-registrations/dict-registrations.component";
import {DictKrkComponent} from "../../../shared/components/dict-krk/dict-krk.component";
import {PartnerFacility} from "../../../shared/interface/partner-facility";
import {
  PartnerFacilityVerificationSalesProcess
} from "../../../shared/interface/partner-facility-verification-sales-process";
import moment from "moment/moment";
import {PersonalDataChange} from "../../../shared/interface/personalDataChange";
import {Device} from "../../../shared/interface/device";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";
const icdates = new Set([1, 26, 53, 17, 22, 37]);

@Component({
  selector: 'app-document-add',
  templateUrl: './document-add.component.html',
  styleUrls: ['./document-add.component.scss']
})
export class DocumentAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() document?: Observable<Document>;
  @Input() contractObject?: Contract;
  @Input() dialogRef?: MatDialogRef<DocumentAddDialogComponent>;
  @Input() allowedTypes?: string[];
  @Input() option?: string;
  @Input() register?: string;
  @Input() ofwcaObject?: Ofwca;
  @Input() partnerObject?: Partner;
  @Input() krkObject?: Krk;
  @Input() registrationObject?: Registration;
  @Input() insuranceCompanyObject?: InsuranceCompany;
  @Input() facilitiesVerificationObject?: PartnerFacilityVerificationSalesProcess;
  @Input() personalDataChangeObject?: PersonalDataChange;
  @Input() competitionImportRowObject?: CompetitionImportRow;
  @Input() deviceObject?: Device;
  @Input() masterModule?: string = null;
  @Output() documentCreated = new EventEmitter<string>();
  @Output() closeModification = new EventEmitter<any>();
  @Input() control?: FormControl;

  readonly FILE_TYPE_ALLIANZ_CERT_FRAUDS = FILE_TYPE_ALLIANZ_CERT_FRAUDS;
  readonly FILE_TYPE_ALLIANZ_CERT = FILE_TYPE_ALLIANZ_CERT;
  readonly FILE_TYPE_ALLIANZ_CERT_MY_CAR = FILE_TYPE_ALLIANZ_CERT_MY_CAR;
  readonly FILE_TYPE_ALLIANZ_CERT_DOCUMENTS = FILE_TYPE_ALLIANZ_CERT_DOCUMENTS;
  readonly FILE_TYPE_IDD_TRAINING_STATEMENT = FILE_TYPE_IDD_TRAINING_STATEMENT;
  readonly FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM = FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM;
  readonly IC_ERGO_HESTIA = IC_ERGO_HESTIA;
  readonly IC_GENERALI = IC_GENERALI;
  readonly IC_INTER_POLSKA = IC_INTER_POLSKA;
  readonly IC_PZU = IC_PZU;
  readonly IC_WARTA = IC_WARTA;
  readonly IC_INTER_POLSKA_LIFE = IC_INTER_POLSKA_LIFE;
  readonly IC_TRASTI = IC_TRASTI;
  readonly IC_METLIFE = IC_METLIFE;
  readonly IC_PRU = IC_PRU;
  readonly FILE_TYPE_AML_CERTIFICATE = FILE_TYPE_AML_CERTIFICATE;
  readonly INSURANCE_COMPANY_MESSAGES = {
    [this.IC_TRASTI]: 'Zaświadczenie 100 pytań OFWCA musi zawierać datę wcześniejszą niż data wystawienia zaświadczenia produktowego z tego TU.',
    [this.IC_ERGO_HESTIA]: 'Zaświadczenia MTU nie są akceptowane.',
    [this.IC_GENERALI]: 'Akceptowane są zaświadczenia produktowe zawierające w treści informację o tym, że egzamin został przeprowadzony w oparciu o Rozporządzenie Ministra Finansów z dnia 21.08.2018r. Zaświadczenia Concordia, PUNU i KNUiFE nie są akceptowane.',
    [this.IC_WARTA]: 'Zaświadczenia HDI nie są akceptowane.',
    [this.IC_INTER_POLSKA]: 'Jeśli zaświadczenie 100 pytań OFWCA zostało wystawione przez spółkę majątkową innego TU, wówczas zakres egzaminu produktowego musi wynosić 30 pytań, w sytuacji gdy 100 pytań OFWCA zostało wystawione przez spółkę życiową innego TU, wówczas wymagany zakres egzaminu to 40 pytań.',
    [this.IC_INTER_POLSKA_LIFE]: 'Jeśli zaświadczenie 100 pytań OFWCA zostało wystawione przez spółkę majątkową innego TU, wówczas zakres egzaminu produktowego musi wynosić 30 pytań, w sytuacji gdy 100 pytań OFWCA zostało wystawione przez spółkę życiową innego TU, wówczas wymagany zakres egzaminu to 40 pytań.',
    [this.IC_PZU]: 'Jeśli zaświadczenie 100 pytań OFWCA zostało wystawione przez spółkę majątkową innego TU, wówczas zakres egzaminu produktowego musi wynosić 30 pytań, w sytuacji gdy 100 pytań OFWCA zostało wystawione przez spółkę życiową innego TU, wówczas wymagany zakres egzaminu to 40 pytań.',
    [this.IC_PRU]: 'Akceptowane są zaświadczenia wystawione przez Prudential International Assurance plc S.A.. Jeśli zaświadczenie 100 pytań OFWCA zostało wystawione przez spółkę majątkową innego TU, wówczas zakres egzaminu produktowego musi wynosić 30 pytań, w sytuacji gdy 100 pytań OFWCA zostało wystawione przez spółkę życiową innego TU, wówczas wymagany zakres egzaminu to 40 pytań.',
    [this.IC_METLIFE]: 'Jeśli zaświadczenie 100 pytań OFWCA zostało wystawione przez spółkę majątkową innego TU, wówczas zakres egzaminu produktowego musi wynosić 30 pytań, w sytuacji gdy 100 pytań OFWCA zostało wystawione przez spółkę życiową innego TU, wówczas wymagany zakres egzaminu to 40 pytań.'
  };

  fileMaxSize = 5242880;
  documentForm: FormGroup;
  documentTypeControl: FormControl;
  contractControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  fileControl: FormControl;
  contentControl: FormControl;
  krkControl: FormControl;
  registrationControl: FormControl;
  insuranceCompanyControl: FormControl;
  partnerFacilityVerificationControl: FormControl;
  currentEntityOfRegistrationControl: FormControl;
  commentsControl: FormControl;
  certDateControl: FormControl;
  dateOfIssueControl: FormControl;
  personalDataChangeControl: FormControl;
  competitionImportRowControl: FormControl;
  deviceProtocolDateControl: FormControl;
  deviceControl: FormControl;
  processingRequest = false;
  requireContract = false;
  requireOfwca = false;
  requireContractOfwca = false;
  requirePartner = false;
  requireKrk = false;
  requireRegistration = false;
  requireInsuranceCompany = false;
  requireCurrentEntityOfRegistration = false;
  requireDocumentInformation = false;
  requireComments = false;
  formErrors = {};
  documentObject?: Document;
  insuranceCompanyKeys?: string[] = null;
  selectedInsuranceCompany: InsuranceCompany = null;
  selectedOfwca: Ofwca = null;
  ofwcaContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  documentsOut: number[] = [223, 567, 387, 386, 417, 432, 58, 415, 64, 317];
  documentsOut2: number[] = [100, 101, 102, 103, 60, 61];
  krkCondition = true;
  pzuCondition = true;
  salesProcess = false;
  initializeBool = false;
  cert40p100p = false;
  certDateRequired = false;
  isAmlCertificate = false;
  documentInformationScanControl: FormControl;
  documentInformationOriginalControl: FormControl;
  documentInformationDocumentMissingControl: FormControl;
  get skipKeys(): string[] {
    const baseSkipKeys = [
      FILE_TYPE_IDD_TRAINING_STATEMENT,
      FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM
    ];

    if (!this.documentObject?.personalDataChange && !this.documentObject?.device) {
      return [
        ...baseSkipKeys,
        FILE_TYPE_ALLIANZ_CERT,
        FILE_TYPE_ALLIANZ_CERT_MY_CAR,
        FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
        FILE_TYPE_ALLIANZ_CERT_FRAUDS,
        FILE_TYPE_PERSONAL_DATA_CHANGE,
        FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE,
        FILE_TYPE_HANDOVER_PROTOCOL,
        FILE_TYPE_RETURN_PROTOCOL,
        FILE_TYPE_AWARD_RECEPTION_PROTOCOL];
    }
    return baseSkipKeys;
  }


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private contractSelectCardComponent: ReplaySubject<ContractSelectCardComponent>
    = new ReplaySubject<ContractSelectCardComponent>(1);
  private krkSelectCardComponent: ReplaySubject<DictKrkComponent>
    = new ReplaySubject<DictKrkComponent>(1);
  constructor(
    private fb: FormBuilder,
    private dictService: DictService,
    private documentService: DocumentService,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ofwcaService: OfwcaService,
  ) {
    this.documentForm = fb.group({
      file: this.fileControl = fb.control('', [Validators.required]),
      filename: fb.control('', [Validators.required]),
      documentName: fb.control(''),
      content: this.contentControl = fb.control(''),
      type: this.documentTypeControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control('', [Validators.required]),
      partner: this.partnerControl = fb.control('', [Validators.required]),
      krk: this.krkControl = fb.control('', [Validators.required]),
      personalDataChange: this.personalDataChangeControl = fb.control(''),
      competitionImportRow: this.competitionImportRowControl = fb.control(''),
      device: this.deviceControl = fb.control(''),
      dateOfIssue: this.dateOfIssueControl = fb.control(''),
      deviceProtocolDate: this.deviceProtocolDateControl = fb.control(''),
      registration: this.registrationControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      facilityVerificationSalesProcessity: this.partnerFacilityVerificationControl = fb.control('', [Validators.required]),
      currentEntityOfRegistration: this.currentEntityOfRegistrationControl = fb.control(''),
      comments: this.commentsControl = fb.control(''),
      certDate: this.certDateControl = fb.control('', [(control: AbstractControl) => {
        if (this.insuranceCompanyControl?.value && icdates.has(this.insuranceCompanyControl.value) && this.cert40p100p) {
          return Validators.required(control);
        }
        return null;
      }, this.CertDateValidator()]),
      documentInformationScan: this.documentInformationScanControl = fb.control(false),
      documentInformationOriginal: this.documentInformationOriginalControl = fb.control(false),
      documentInformationDocumentMissing: this.documentInformationDocumentMissingControl = fb.control(false),
    });
    this.documentForm.get('documentName').disable();

    this.activatedRoute.data
      .pipe(
        first()
      )
      .subscribe((data: any) => {
        this.masterModule = this.masterModule ?? data.masterModule ?? null;
      });
  }

  @ViewChild('contractSelectCardComponent') set content(content: ContractSelectCardComponent) {
    if (content) {
      this.contractSelectCardComponent.next(content);
      content.ownerControl.valueChanges
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {
          if (this.documentsOut.includes((this.documentTypeControl.value))){
            if (content.ownerControl.value === 79){
              content.ofwcaControl.setValue(null);
              content.ofwcaControl.reset();
              content.control.setValue(null);
            } else {
              content.partnerControl.setValue(null);
              content.partnerControl.reset();
              content.control.setValue(null);
            }
          }
        });
      content.partnerControl.valueChanges
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {
          content.control.setValue(null);
          content.control.reset();
        });
    }
  }
  @ViewChild('krkSelectCardComponent') set content3(content: DictKrkComponent) {
    if (content) {
      this.krkSelectCardComponent.next(content);
      this.krkCondition = content.krkDocuments;
    }}
      ngOnInit(): void {

    this.documentForm.get('file').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {

        this.fileControl.value.forEach((fileToRead: File) => {
          this.documentForm.get('filename').setValue(fileToRead.name);
          this.documentForm.get('content').reset('');
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.documentForm.get('content').setValue(
              this.documentForm.get('content').value +
              (this.documentForm.get('content').value ? ', ' : '') +
              (/base64,(.+)/.exec(reader.result.toString())[1])
            );
          };
        });
      });
    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe(() => {
        if (!this.initializeBool ) {
          if (!this.registrationObject){
            this.registrationControl.reset();
          }
          if (this.requireContractOfwca) {
            this.ofwcaService.getOfwcaContractsRegistrations(this.ofwcaControl.value)
              .pipe(takeUntil(this.destroyed$))
              .subscribe((contracts: ListResponse<Contract>) => {
                this.ofwcaContracts.next(contracts.items);
              });
          }
          if (this.documentsOut2.includes(this.documentTypeControl.value)){
            if (this.register === "register") {
              this.insuranceCompanyControl.disable();
            }else{
                this.registrationControl.setValue(null);
                this.registrationControl.reset();
            }
          }
          if (this.documentTypeControl.value === 62 && this.option !== "KRK") {
            this.krkControl.reset();
            this.krkControl.setValue(null);
          }
          if (this.documentTypeControl.value === 564) {
            if (!this.requireRegistration) {
              this.registrationControl.reset();
              this.registrationControl.setValue(null);
            }
            if (!this.requireComments) {
              this.commentsControl.reset();
            }
            if (!this.requireCurrentEntityOfRegistration) {
              this.currentEntityOfRegistrationControl.reset();
            }
          }
        }
      }
    );
        this.documentInformationScanControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationOriginalControl.setValue(false);
          this.documentInformationDocumentMissingControl.setValue(false);
        }
      });

    this.documentInformationOriginalControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationScanControl.setValue(false);
          this.documentInformationDocumentMissingControl.setValue(false);
        }
      });

    this.documentInformationDocumentMissingControl.valueChanges
      .pipe(takeUntil(this.destroyed$), distinctUntilChanged())
      .subscribe((val: boolean) => {
        if (val) {
          this.documentInformationOriginalControl.setValue(false);
          this.documentInformationScanControl.setValue(false);
        }
      });

    this.insuranceCompanyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (!this.initializeBool) {
          if (!this.registrationObject){
            this.registrationControl.reset();
          }
        }
        if (this.documentTypeControl.value === 59 || this.documentTypeControl.value === 286) {
            this.pzuCondition = false;
          } else {
            this.pzuCondition = true;
          }
        if (icdates.has(this.insuranceCompanyControl.value) && this.cert40p100p) {
          this.certDateControl.setValidators([Validators.required, this.CertDateValidator()]);
        this.certDateRequired = true;
        } else {
          this.certDateRequired = false;
          this.certDateControl.clearValidators();
          this.certDateControl.reset();
        }
        this.certDateControl.updateValueAndValidity({ emitEvent: true });
      });

    this.documentTypeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((dictId: number) => {
      this.pzuCondition = true;
      this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            this.resetRequires();
            this.salesProcess = false;
            this.cert40p100p = false;
            if ([FILE_TYPE_IDD_TRAINING_STATEMENT].includes(dictKey)) {
              this.salesProcess = true;
            }

              if ([
                FILE_TYPE_CERT_100P,
                FILE_TYPE_CERT_40P,
              ].includes(dictKey)) {
                this.cert40p100p = true;
              }else{
                this.certDateControl.clearValidators();
                this.certDateControl.setValue(null);
              }

            if ([
              FILE_TYPE_CONTRACT,
              FILE_TYPE_CONTRACT_TERMINATION,
              FILE_TYPE_ANNEX,
              FILE_TYPE_OFWCA_APPLICATION,
              FILE_TYPE_ANNEX_OFWCA_APPLICATION,
              FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
              FILE_TYPE_CONFIDENTIALITY_AGREEMENT,
              FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE,
              FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS,
              FILE_TYPE_RECEIPT_PROTOCOL,
              FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
              FILE_TYPE_ANNEX_LEAD,
              FILE_TYPE_ANNEX_AUTOMATIC_BILLING,
              FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING,
              FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING
            ].includes(dictKey)) {
              this.requireContractSelect();
            }

            if ([
              FILE_TYPE_DIPLOMA,
              FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
              FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
            ].includes(dictKey)) {
              this.requireOfwcaSelect();
            }

            if ([
              FILE_TYPE_KRS_CEIDG,
              FILE_TYPE_PARTNER_DATA,
              FILE_TYPE_OVERCOMMISSION_AGREEMENT,
              FILE_TYPE_MANDATE_QUESTIONNAIRE,
            ].includes(dictKey)) {
              this.requirePartnerSelect();
            }

            if ([FILE_TYPE_KRK].includes(dictKey)) {
                if (this.option !== "KRK"){
                  this.requireKrkSelect();
                  this.requireOfwcaSelect();
                } else {
                  this.requireKrkSelect();
                }
            }

            if ([FILE_TYPE_AUTHORIZATION, FILE_TYPE_CERT_40P].includes(dictKey)) {
              this.requireOfwcaSelect();
              this.requireInsuranceCompanySelect();
              this.requireRegistrationSelect();
              }

            if ([FILE_TYPE_ALLIANZ_CERT,
              FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
              FILE_TYPE_ALLIANZ_CERT_FRAUDS,
              FILE_TYPE_ALLIANZ_CERT_MY_CAR
            ].includes(dictKey)) {
              if (this.register === "register") {
              return;
              } else {
                this.requireRegistrationSelect();
                this.requireInsuranceCompanySelect();
                this.requireOfwcaSelect();
              }
            }

            if ([FILE_TYPE_CERT_100P].includes(dictKey)) {
              this.requireInsuranceCompanySelect();
              this.requireOfwcaSelect();
            }

            if ([FILE_TYPE_AML_CERTIFICATE].includes(dictKey)) {
              this.requireInsuranceCompanySelect();
              this.requireOfwcaSelect();
              this.isAmlCertificate = true;
            }

            if ([FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU].includes(dictKey)) {
              this.requireInsuranceCompanySelect();
              this.requireOfwcaSelect();
              this.insuranceCompanyKeys = [
                IC_PZU, IC_PZU_LIFE,
              ];
            }

            if ([FILE_TYPE_INITIAL_TRAINING].includes(dictKey)) {
              this.requireRegistrationSelect();
              this.requireInsuranceCompanySelect();
              this.insuranceCompanyKeys = [
                IC_INTER_POLSKA, IC_INTER_POLSKA_LIFE,
              ];
            }
            if ([FILE_TYPE_ANOTHER_MULTI].includes(dictKey)) {
              this.requireDocumentInformationSelect();
              this.requireRegistrationSelect();
              this.requireInsuranceCompanySelect();
              this.requireOfwcaSelect();
              this.commentsSelect();
              this.currentEntityOfRegistrationSelect();
            } else {
              this.documentForm.setValidators(null);
              this.documentForm.updateValueAndValidity();
            }

            if ([FILE_TYPE_CONTRACT_WITH_EMPLOYEE].includes(dictKey)) {
              this.requireOfwcaSelect();
              this.requireContractOfwcaSelect();
              this.ofwcaService.getOfwcaContractsRegistrationsPartnership(this.ofwcaControl.value)
                .subscribe((contracts: ListResponse<Contract>) => {
                  this.ofwcaContracts.next(contracts.items);
                });
            }
          });
      });

    if (this.contractObject) {
      this.contractControl.setValue(this.contractObject.uuid);
    }

    if (this.ofwcaObject) {
      this.ofwcaControl.setValue(this.ofwcaObject.uuid);
    }

    if (this.partnerObject) {
      this.partnerControl.setValue(this.partnerObject.uuid);
    }

    if (this.krkObject) {
      this.krkControl.setValue(this.krkObject.uuid);
    }

    if (this.registrationObject) {
      this.registrationControl.setValue(this.registrationObject.uuid);
      this.insuranceCompanyControl.disable();
    }

    if (this.insuranceCompanyObject) {
      this.insuranceCompanyControl.setValue(this.insuranceCompanyObject.id);
    }
    if (this.facilitiesVerificationObject) {
      this.partnerFacilityVerificationControl.setValue(this.facilitiesVerificationObject.id);
    }

    if (this.personalDataChangeObject) {
      this.personalDataChangeControl.setValue(this.personalDataChangeObject.uuid);
    }

    if (this.competitionImportRowObject) {
      this.competitionImportRowControl.setValue(this.competitionImportRowObject.uuid);
    }

    if (this.deviceObject) {
      this.deviceControl.setValue(this.deviceObject.uuid);
    }
  }

  ngAfterViewInit(): void {
    if (this.document) {
      this.document
        .pipe(
          delay(0),
          takeUntil(this.destroyed$)
        )
        .subscribe((document: Document) => {
          this.documentObject = document;
          this.initialize(document);
        });
    }
  }
  // oneRequiredValidator(): ValidatorFn {
  //   return (group: AbstractControl): { [key: string]: any } | null => {
  //
  //     const checkedCount = [
  //       group.get('documentInformationScan')?.value,
  //       group.get('documentInformationOriginal')?.value,
  //       group.get('documentInformationDocumentMissing')?.value
  //     ].filter(Boolean).length;
  //
  //     return checkedCount === 1 ? null : { oneRequired: true };
  //   };
  // }

  onInsuranceCompanySelected(selectedCompany: any): void {
    this.selectedInsuranceCompany = selectedCompany;
  }
  hasInsuranceCompanyMessage(): boolean {
    return !!(
      (this.selectedInsuranceCompany?.key && this.INSURANCE_COMPANY_MESSAGES[this.selectedInsuranceCompany.key]) ||
      (this.registrationObject?.insuranceCompany?.key && this.INSURANCE_COMPANY_MESSAGES[this.registrationObject.insuranceCompany.key])
    );
  }

  resetRequires(): void {
    this.insuranceCompanyKeys = null;
    this.requireContract = false;
    this.requireContractOfwca = false;
    this.requireOfwca = false;
    this.requirePartner = false;
    this.requireKrk = false;
    this.requireRegistration = false;
    this.requireInsuranceCompany = false;
    this.requireCurrentEntityOfRegistration = false;
    this.requireComments = false;
    this.requireDocumentInformation = false;
    this.contractControl.disable();
    this.ofwcaControl.disable();
    this.partnerControl.disable();
    this.krkControl.disable();
    this.registrationControl.disable();
    this.insuranceCompanyControl.disable();
    this.partnerFacilityVerificationControl.disable();
    this.currentEntityOfRegistrationControl.disable();
    this.commentsControl.disable();
    this.isAmlCertificate = false;
  }

  requireContractSelect(): void {
    this.requireContract = true;
    this.contractControl.enable();
  }

  requireContractOfwcaSelect(): void {
    this.requireContractOfwca = true;
    this.contractControl.enable();
  }
  requireOfwcaSelect(): void {
    this.requireOfwca = true;
    this.ofwcaControl.enable();
  }

  requirePartnerSelect(): void {
    this.requirePartner = true;
    this.partnerControl.enable();
  }

  requireKrkSelect(): void {
    this.requireKrk = true;
    this.krkControl.enable();
  }

  requireRegistrationSelect(): void {
    this.requireRegistration = true;
    this.registrationControl.enable();
  }


  requireInsuranceCompanySelect(): void {
    this.requireInsuranceCompany = true;
    this.insuranceCompanyControl.enable();
    if (this.registrationObject) {
      this.insuranceCompanyControl.disable();
    }
  }

  requireDocumentInformationSelect(): void {
    this.requireDocumentInformation = true;
    this.documentInformationScanControl.enable();
    this.documentInformationOriginalControl.enable();
    this.documentInformationDocumentMissingControl.enable();
  }

  currentEntityOfRegistrationSelect(): void {
    this.requireCurrentEntityOfRegistration = true;
    this.currentEntityOfRegistrationControl.enable();
  }


  commentsSelect(): void {
    this.requireComments = true;
    this.commentsControl.enable();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(resetForm = false): void {
    if (!this.documentForm.valid) {
      this.documentForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.documentForm, this.formErrors);
    this.formErrors = {};

    this.documentService.sendForm(this.documentForm.getRawValue(), this.documentObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.documentObject ? 'Pomyślnie zaktualizowano dokument'
          : 'Pomyślnie utworzono dokument', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (resetForm) {
          this.dictService.getKey(this.documentTypeControl.value)
            .subscribe((dictKey: string) => {
              if (dictKey === FILE_TYPE_ANOTHER_MULTI){
                const formValue = this.documentForm.value;
                this.documentForm.reset({
                  type: formValue.type,
                  insuranceCompany: formValue.insuranceCompany,
                });
              }else {
                this.documentForm.reset({});
              }
            });
          return;
        }

        if (this.dialogRef) {
          this.documentCreated.emit(response.uuid);
        } else if (this.document) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/dokumenty/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open(this.documentObject ? 'Podczas aktualizacji dokumentu wystąpił błąd'
          : 'Podczas tworzenia dokumentu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.snack.open(error.error.error.text, '400', {duration: 4000});
          this.formHelper.setBackendErrorState(this.documentForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (this.document) {
      this.closeModification.emit();
      return;
    }

    if (!this.dialogRef) {
      this.router.navigate(['/dokumenty']);
    } else {
      this.dialogRef.close();
    }
  }

  private CertDateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value || !this.insuranceCompanyControl?.value || !icdates.has(this.insuranceCompanyControl.value) || !this.cert40p100p) {
        return null;
      }
      const inputDate = moment(control.value);

      if (inputDate.isAfter(moment(), 'day')) {
        return { futureDate: { value: control.value } };
      }

      const companyDateMap: { [key: number]: string | (() => moment.Moment) } = {
        1: () => moment().subtract(12, 'months'),
        26: () => moment().subtract(12, 'months'),
        53: '2023-07-01',
        17: '2020-02-01',
        22: '2021-06-01',
        37: '2021-06-01',
      };

      const getDate = companyDateMap[this.insuranceCompanyControl.value];
      if (getDate) {
        const validDate = typeof getDate === 'function' ? getDate() : moment(getDate);
        if (inputDate.isBefore(validDate)) {
          return { invalidDate: { value: control.value } };
        }
      }
      return null;
    };
  }

  private initialize(document: Document): void {
    of(document)
      .pipe(
        takeUntil(this.destroyed$),
        delay(0),
        tap(() => {
          this.initializeBool = true;
          this.contentControl.clearValidators();
          this.fileControl.setValidators([]);

          this.documentForm.reset({
            filename: document.filename,
            type: document.type.id,
            documentName: document.documentName,
          });

          if ([
            FILE_TYPE_CONTRACT,
            FILE_TYPE_CONTRACT_TERMINATION,
            FILE_TYPE_ANNEX,
            FILE_TYPE_OFWCA_APPLICATION,
            FILE_TYPE_ANNEX_OFWCA_APPLICATION,
            FILE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
            FILE_TYPE_CONFIDENTIALITY_AGREEMENT,
            FILE_TYPE_STATEMENT_ON_THE_RIGHT_TO_DISPOSE_OF_REAL_ESTATE,
            FILE_TYPE_DECLARATION_OF_CONSENT_TO_MAKE_COMMISSION_DEDUCTIONS,
            FILE_TYPE_RECEIPT_PROTOCOL,
            FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
            FILE_TYPE_ANNEX_LEAD,
            FILE_TYPE_ANNEX_AUTOMATIC_BILLING,
            FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING,
            FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING
          ].includes(document.type.key)) {
            this.contractSelectCardComponent
              .pipe(first())
              .subscribe((component: ContractSelectCardComponent) => component.initialize(document.contract));
          } else if ([
            FILE_TYPE_DIPLOMA,
            FILE_TYPE_AGREEMENT_ON_WALLET_REASSIGN,
            FILE_TYPE_OFWCA_APPLICATION,
            FILE_TYPE_INFORMATION_CLAUSE_FOR_OFWCA,
          ].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
          } else if ([
            FILE_TYPE_KRS_CEIDG,
            FILE_TYPE_PARTNER_DATA,
            FILE_TYPE_OVERCOMMISSION_AGREEMENT
          ].includes(document.type.key)) {
            this.partnerControl.setValue(document.partner.uuid);
          } else if ([FILE_TYPE_KRK].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.krkControl.setValue(document.krk.uuid);
          } else if ([FILE_TYPE_PERSONAL_QUESTIONNAIRE_PZU].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
            this.registrationControl.setValue(document.registration.uuid);
          } else if ([FILE_TYPE_CERT_100P].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
            this.certDateControl.setValue(moment(document.certDate));
          } else if ([
            FILE_TYPE_ALLIANZ_CERT,
            FILE_TYPE_ALLIANZ_CERT_DOCUMENTS,
            FILE_TYPE_ALLIANZ_CERT_FRAUDS,
            FILE_TYPE_ALLIANZ_CERT_MY_CAR,
            FILE_TYPE_AUTHORIZATION,
            FILE_TYPE_CERT_40P,
          ].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
            this.selectedInsuranceCompany = document.insuranceCompany;
            this.registrationControl.setValue(document.registration.uuid);
            this.certDateControl.setValue(moment(document.certDate));
          } else if (document.type.key === FILE_TYPE_INITIAL_TRAINING) {
            this.registrationControl.setValue(document.registration.uuid);
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
          }else if (document.type.key === FILE_TYPE_ANOTHER_MULTI) {
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.currentEntityOfRegistrationControl.setValue(document.registration?.currentEntityOfRegistration);
            this.commentsControl.setValue(document.registration?.comments);
            this.selectedInsuranceCompany = document.insuranceCompany;
            this.registrationControl.setValue(document.registration.uuid);
            this.documentInformationScanControl.setValue(document.documentInformationScan);
            this.documentInformationOriginalControl.setValue(document.documentInformationOriginal);
            this.documentInformationDocumentMissingControl.setValue(document.documentInformationDocumentMissing);
          }else if ([
            FILE_TYPE_CONTRACT_WITH_EMPLOYEE,
          ].includes(document.type.key)) {
            this.requireContractOfwca = true;
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.contractControl.setValue(document.contract.uuid);
            // this.contractControl.setValue(this.contractObject.uuid);

          }else if ([
            FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM,
          ].includes(document.type.key)) {
            this.partnerFacilityVerificationControl.setValue(document.facilityVerification.id);
            // this.contractControl.setValue(this.contractObject.uuid);

          }else if ([
            FILE_TYPE_PERSONAL_DATA_CHANGE,
            FILE_TYPE_CONFIRMATION_PERSONAL_DATA_CHANGE
          ].includes(document.type.key)) {
            this.personalDataChangeControl.setValue(document.personalDataChange.uuid);
            this.documentTypeControl.setValue(document.type.id);
            this.documentTypeControl.disable();
          }else if ([
            FILE_TYPE_HANDOVER_PROTOCOL,
            FILE_TYPE_RETURN_PROTOCOL
          ].includes(document.type.key)) {
            this.deviceControl.setValue(document.device.uuid);
            this.documentTypeControl.setValue(document.type.id);
            this.deviceProtocolDateControl.setValue(document.deviceProtocolDate);
            this.documentTypeControl.disable();
          }
          else if ([
            FILE_TYPE_AML_CERTIFICATE,
          ].includes(document.type.key)) {
            this.ofwcaControl.setValue(document.ofwca.uuid);
            this.insuranceCompanyControl.setValue(document.insuranceCompany.id);
            this.dateOfIssueControl.setValue(moment(document.dateOfIssue));
          }
          this.initializeBool = false;
        })
      ).subscribe();
  }

}
